module.exports = __webpack_public_path__ + "img/sri-lanka.7a136cf7.svg";